const initialState = {
  permissionsDomkom: null
}

const permissionsDomkom = (state = initialState, action) => {
  switch (action.type) {
    case "PERMISSIONS_DOMKOM":
      return { ...state, permissionsDomkom: action.val }
    default:
      return state
  }
}
export default permissionsDomkom
